import Api, { API_ROOT as API, ACCOUNT_USER, ACCOUNT_PING, ACCOUNT_TOKEN, ACCOUNT_LOGIN, ACCOUNT_LOGOUT, ACCOUNT_CHANGE_PASSWORD, ACCOUNT_RESET_PASSWORD, ACCOUNT_FORGOT_PW, ACCOUNT_FORGOT_PW_CONFIRM, VALIDATE_MFA_CODE } from '@defi/core-api';
import Logout from './logout';
import Token from './token';
import Location from './location';
import { PATH_ROOT, PATH_DASHBOARD, PATH_LOGIN_EXPIRED, ROUTE_LOGIN_EXPIRED, REQUIRE_AUTH } from '@defi/core-constants';
import filterByPathAndArea from './filterByPathAndArea';
import { List } from 'immutable';
let Auth = {
  profile() {
    let profileCondition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PasswordExpired';
    let token = new Token();
    let currentProfile = token.getProfile();
    return currentProfile[profileCondition];
  },
  can() {
    let canPermission = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let token = new Token();
    let currentPermissions = token.getPermissions();
    return currentPermissions && currentPermissions.List && currentPermissions.List.indexOf(canPermission) > -1;
  },
  ping() {
    return Api.get(API.auth, ACCOUNT_PING).then(function (response) {
      let token = new Token();
      let currentProfile = token.getProfile();
      let pingUsername = response.username.toLowerCase();
      let profileUsername = currentProfile.UserName.toLowerCase();
      if (pingUsername.localeCompare(profileUsername) === 0) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
      }
    }).catch(function (error) {
      if (error && error.response && error.response.status === 401) {
        Logout.logoutDirectlyToNewLogout();
      }
    });
  },
  user() {
    return Api.get(API.auth, ACCOUNT_USER).then(response => {
      if (response.hasOwnProperty('success') && response.success) {
        let token = new Token();
        token.deleteSession();
        token.setExpiration(response.expires);
        token.setProfile(response.Profile);
        token.setPermissions(response.Permissions);
        token.setPagePermissions(response.PagePermissions);
        token.setCreated(response.created);
        token.setRefresh(response.refresh);
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
      }
    }).catch(function (error) {
      return Promise.reject(error);
    });
  },
  token() {
    return Api.get(API.auth, ACCOUNT_TOKEN).then(response => {
      let token = new Token();
      token.setExpiration(response.expires);
      token.setProfile(response.Profile);
      token.setPermissions(response.Permissions);
      token.setPagePermissions(response.PagePermissions);
      token.setCreated(response.created);
      token.setRefresh(response.refresh);
      return Promise.resolve(response);
    }).catch(function (error) {
      return Promise.reject(error);
    });
  },
  verifyIsDefiUser() {
    // Get our data
    let token = new Token();
    let currentExpiration = token.getExpiration();
    let currentProfile = token.getProfile();
    if (currentExpiration === null) {
      Logout.logoutDirectlyToNewLogout();
    }
    // Check expiration
    let expiredDate = currentExpiration;
    let currentTime = new Date().getTime();
    let currentTimeStamp = Math.floor(currentTime / 1000);
    if (expiredDate <= currentTimeStamp) {
      Logout.logoutDirectlyToNewLogout();
    }

    // Check ForceLogoff field
    if (!currentProfile || currentProfile.ForceLogoff === true) {
      Logout.logoutForced();
    }

    // Check PasswordExpired field
    if (currentProfile.PasswordExpired === true && path !== ROUTE_LOGIN_EXPIRED) {
      // eslint-disable-next-line
      Location.redirect(PATH_LOGIN_EXPIRED);
    }
    return currentProfile.UserName.startsWith('defi-');
  },
  verification() {
    let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let requireEditAbility = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let ignorePermissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let requiredConditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // Get our data
    let token = new Token();
    let currentExpiration = token.getExpiration();
    let currentProfile = token.getProfile();
    let currentPagePermissions = token.getPagePermissions();
    if (currentExpiration === null) {
      Logout.logoutDirectlyToNewLogout();
    }
    // Check expiration
    let expiredDate = currentExpiration;
    let currentTime = new Date().getTime();
    let currentTimeStamp = Math.floor(currentTime / 1000);
    if (expiredDate <= currentTimeStamp) {
      Logout.logoutDirectlyToNewLogout();
    }

    // Check ForceLogoff field
    if (!currentProfile || currentProfile.ForceLogoff === true) {
      Logout.logoutForced();
    }

    // Check PasswordExpired field
    if (currentProfile.PasswordExpired === true && path !== ROUTE_LOGIN_EXPIRED) {
      // eslint-disable-next-line
      Location.redirect(PATH_LOGIN_EXPIRED);
    }

    // Check if we are ignoring permissions and skip check below
    if (ignorePermissions) {
      if (requiredConditions && requiredConditions.Can && !this.can(requiredConditions.Can)) {
        // redirect to dashboard doesn't have needed Can Permission
        Location.redirect(PATH_DASHBOARD);
      }

      // check if needs a Profile Condition
      if (requiredConditions && requiredConditions.Profile && !this.profile(requiredConditions.Profile)) {
        // redirect to dashboard doesn't have needed Profile Condition
        Location.redirect(PATH_DASHBOARD);
      }
      return true;
    }
    if (!currentPagePermissions) {
      return false;
    }
    const viewAndEditPermissions = Array.isArray(currentPagePermissions.CanViewAndEdit) ? currentPagePermissions.CanViewAndEdit : [];
    const viewPermissions = Array.isArray(currentPagePermissions.CanView) ? currentPagePermissions.CanView : [];

    // Check CanView and CanViewAndEdit permissions
    //  - Users may have only CanViewAndEdit permissions
    //  - Users may have both permissions
    if (viewAndEditPermissions.filter(filterByPathAndArea(path)).length === 1) {
      return true;
    } else if (!requireEditAbility && viewPermissions.filter(filterByPathAndArea(path)).length === 1) {
      return true;
    } else {
      // if (path === PATH_ROOT) {
      //   window.location = PATH_DASHBOARD;
      // } else {
      return false;
      // }
    }

    // We are looking good
    return true;
  },
  login(username, password) {
    return Api.post(API.auth, ACCOUNT_LOGIN, {
      username,
      password,
      rememberMe: true
    }).then(response => {
      if (response.MfaChallenge) {
        let token = new Token();
        token.setMfaSession(response.MfaChallenge);
        return Promise.resolve(response);
      } else if (Object.keys(response).length !== 0) {
        let token = new Token();
        token.setExpiration(response.expires);
        token.setCreated(response.created);
        token.setRefresh(response.refresh);
        token.setProfile(response.Profile);
        token.setPermissions(response.Permissions);
        token.setPagePermissions(response.PagePermissions);
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
        //return Promise.reject(new Error('Unable to retrieve data.'));
      }
    }).catch(function (error) {
      return Promise.reject(error);
      //return Promise.reject(new Error('Unable to retrieve data.'));
    });
  },
  ssoLogin(response) {
    if (Object.keys(response).length !== 0) {
      let token = new Token();
      token.setExpiration(response.expires);
      token.setCreated(response.created);
      token.setRefresh(response.refresh);
      token.setProfile(response.Profile);
      token.setPermissions(response.Permissions);
      token.setPagePermissions(response.PagePermissions);
      return Promise.resolve(response);
    }
  },
  validateMfa(username, password, mfacode, rememberMe) {
    let token = new Token();
    let mfaSessionData = token.getMfaSession();
    let mfaSession = mfaSessionData.SessionId;
    return Api.post(API.auth, VALIDATE_MFA_CODE, {
      username,
      password,
      mfacode,
      mfaSession,
      MfaRememberThisDeviceRequested: rememberMe
    }).then(response => {
      if (Object.keys(response).length !== 0) {
        let token = new Token();
        token.setExpiration(response.expires);
        token.setCreated(response.created);
        token.setRefresh(response.refresh);
        token.setProfile(response.Profile);
        token.setPermissions(response.Permissions);
        token.setPagePermissions(response.PagePermissions);
        token.deleteMfaSession();
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
        //return Promise.reject(new Error('Unable to retrieve data.'));
      }
    }).catch(function (error) {
      return Promise.reject(error);
      //return Promise.reject(new Error('Unable to retrieve data.'));
    });
  },
  changePassword(username, newPassword, clientID, currentPassword, mfaAccessToken) {
    let body = {
      Username: username,
      NewPassword: newPassword,
      ClientId: clientID,
      CurrentPassword: currentPassword
    };
    if (mfaAccessToken && mfaAccessToken.length > 0) body.AccessToken = mfaAccessToken;
    return Api.post(API.auth, ACCOUNT_CHANGE_PASSWORD, body).then(response => {
      if (Object.keys(response).length !== 0) {
        if (response.Errors) return Promise.resolve(response);
        let token = new Token();
        token.setExpiration(response.expires);
        token.setProfile(response.Profile);
        token.setPermissions(response.Permissions);
        token.setPagePermissions(response.PagePermissions);
        return Promise.resolve(response);
      }
    }).catch(function (error) {
      return Promise.reject(new Error('Unable to retrieve data.'));
    });
  },
  resetPassword(username, newPassword, clientID) {
    return Api.post(API.auth, ACCOUNT_RESET_PASSWORD, {
      Username: username,
      NewPassword: newPassword,
      ClientId: clientID
    });
  },
  forgotPassword(username, clientID) {
    return Api.post(API.auth, ACCOUNT_FORGOT_PW, {
      UserName: username
    });
  },
  forgotPasswordConfirm(username, password, mfaCode, clientID) {
    return Api.post(API.auth, ACCOUNT_FORGOT_PW_CONFIRM, {
      UserName: username,
      Password: password,
      ConfirmationCode: mfaCode
    });
  },
  userPermissionMatchLocalStorage(user) {},
  user() {
    return Api.get(API.auth, ACCOUNT_USER).then(response => {
      if (Object.keys(response).length !== 0) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.Message));
        //return Promise.reject(new Error('Unable to retrieve data.'));
      }
    }).catch(function (error) {
      new Token().deleteSession();
      return Promise.reject(error);
    });
  },
  canView() {
    let pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let authOff = arguments.length > 1 ? arguments[1] : undefined;
    // Check if auth is turned off
    if (!REQUIRE_AUTH || authOff) {
      return true;
    }

    // Get path & page permissions
    let currentPagePermissions = new Token().getPagePermissions();
    if (currentPagePermissions == null) {
      return false;
    } else {
      const viewPermissions = Array.isArray(currentPagePermissions.CanView) ? currentPagePermissions.CanView : [];
      if (pathname == null) {
        pathname = window.location.pathname;
      }
      let pathnameAlt = null;
      if (pathname.substr(-1) !== '/') {
        pathnameAlt = pathname + '/';
      }

      // Check if pathname is in page permissions
      if (viewPermissions.filter(filterByPathAndArea(pathname)).length === 1 || pathnameAlt !== null && viewPermissions.filter(filterByPathAndArea(pathnameAlt)).length === 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  canViewAndEdit() {
    let pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let authOff = arguments.length > 1 ? arguments[1] : undefined;
    // Check if auth is turned off
    if (!REQUIRE_AUTH || authOff) {
      return true;
    }

    // Get path & page permissions
    let currentPagePermissions = new Token().getPagePermissions();
    if (currentPagePermissions == null) {
      return false;
    } else {
      const viewAndEditPermissions = Array.isArray(currentPagePermissions.CanViewAndEdit) ? currentPagePermissions.CanViewAndEdit : [];
      if (pathname == null) {
        pathname = window.location.pathname;
      }
      let pathnameAlt = null;
      if (pathname.substr(-1) !== '/') {
        pathnameAlt = pathname + '/';
      }

      // Check if pathname is in page permissions
      if (viewAndEditPermissions.filter(filterByPathAndArea(pathname)).length === 1 || pathnameAlt !== null && viewAndEditPermissions.filter(filterByPathAndArea(pathnameAlt)).length === 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  checkPermissions() {
    let permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : List([]);
    // Get special permissions
    let currentPermissions = new Token().getPermissions();

    // Make sure the data type of the permissions object is a list
    if (!List.isList(permissions)) {
      return false;
    }

    // Make sure some permissions were passed or check them
    if (permissions.size < 1) {
      return true;
    } else if (!currentPermissions) {
      return false;
    } else {
      // Verify all permissions are in the list
      for (let i = 0, len = permissions.size; i < len; i++) {
        if (currentPermissions.List.indexOf(permissions.get(i)) < 0) {
          return false;
        }
      }
    }

    // All good!
    return true;
  },
  logoutCleanup() {
    const token = new Token();
    token.deleteSession();
    token.deleteMfaSession();
    return Api.post(API.auth, ACCOUNT_LOGOUT);
  },
  logout() {
    Logout.logout();
  },
  logoutForced() {
    Logout.logoutForced();
  },
  logoutDirectlyToNewLogout() {
    Logout.logoutDirectlyToNewLogout();
  },
  onChange() {}
};
export { Logout, Token, Location };
export * from './reducers';
export * from './actions';
export * from './sagas';
export { default as hasPermission } from './hasPermission';
export * from './lockStatus';
export default Auth;